import { useRef } from 'react';
import '../style/Education.scss';
import { useScrollFadeIn } from '../hooks/useScrollTrigger';

function Education(props) {
    const pic = useRef(null);

    // Fade in animation
    useScrollFadeIn(pic);

  return (
    <div className='section3' id='education' ref={props.educationRef}>
        <div className='leftSide'>
            <h1 className='header'>Education</h1>
            <p className='paragraph'>
                I graduated from the University of Vermont in 2023 with a Bachelor's Degree in Computer Science.
                I started my college journey as a mechanical engineer. For one of my required classes I was introduced
                to the beautiful language we all know as Python. I fell in love with coding and decided to switch my major
                to Computer Science. Since then I have loved every minute of it and have been teaching myself new languages
                and frameworks in my free time.
            </p>
        </div>
        <div className='rightSide' ref={pic}>
            <img className='uvm' src="images/uvm_campus_animated.png" alt='University of Vermont' />
        </div>
    </div>
  );
}

export default Education;